import { SortModelItem } from "ag-grid-enterprise";
import { SelectableFilterQueryBase } from "../../common/selectableFilterQueryBase";

export interface ManagedStockSearchFilterQuery extends SelectableFilterQueryBase {
    keyword?: string;
    contains?: boolean;
    departmentIds?: number[];
    manufacturerIds?: number[];
    subdepartmentIds?: number[];
    supplierIds?: number[];
    stockGroupIds?: number[];
    searchPdes?: boolean;
    searchBarcodes?: boolean;
    active?: boolean | null;
    ethical?: boolean | null;
    schedule?: string;
    pbs?: boolean | null;
    linkedToSystem?: boolean | null;
    productIds?: number[];
    loadDetails?: ManagedStockSearchFilterQueryLoadDetails[];
    sortModels?: SortModelItem[]
}

export enum ManagedStockSearchFilterQueryLoadDetails {
    Pdes,
    Apns
}